import { useEffect } from 'react'
import { CheckCircle, AlertTriangle, XCircle, Info, X } from 'lucide-react'
import { useUIStore } from '../../store/uiStore'
import { cn } from '../../utils'

const config = {
  success: { icon: CheckCircle, styles: 'bg-white border-emerald-400 text-emerald-700', iconClass: 'text-emerald-500' },
  warning: { icon: AlertTriangle, styles: 'bg-white border-amber-400 text-amber-700',   iconClass: 'text-amber-500' },
  error:   { icon: XCircle,      styles: 'bg-white border-red-400 text-red-700',        iconClass: 'text-red-500' },
  info:    { icon: Info,         styles: 'bg-white border-blue-400 text-blue-700',      iconClass: 'text-blue-500' },
}

function Toast({ id, type = 'info', title, message }) {
  const removeToast = useUIStore((s) => s.removeToast)
  const { icon: Icon, styles, iconClass } = config[type] || config.info

  return (
    <div
      className={cn(
        'flex items-start gap-3 min-w-[300px] max-w-sm w-full',
        'border-l-4 rounded-lg shadow-lg p-4 animate-fade-in',
        styles
      )}
      role="alert"
    >
      <Icon className={cn('h-5 w-5 shrink-0 mt-0.5', iconClass)} />
      <div className="flex-1 min-w-0">
        {title   && <p className="font-semibold text-sm text-slate-900">{title}</p>}
        {message && <p className="text-xs text-slate-600 mt-0.5">{message}</p>}
      </div>
      <button
        onClick={() => removeToast(id)}
        className="text-slate-400 hover:text-slate-600 shrink-0"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}

export default function ToastContainer() {
  const toasts = useUIStore((s) => s.toasts)

  return (
    <div
      aria-live="polite"
      className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 items-end"
    >
      {toasts.map((t) => (
        <Toast key={t.id} {...t} />
      ))}
    </div>
  )
}
